export default "__VITE_ASSET__Db0ebKwo__"